import React from 'react';
import { useCurrentUser, useIntl } from 'hooks';
import { IconShieldOutline } from 'icons';
import IndexPublisher from 'types/IndexPublisher';
import Pills from './Pills';

interface Props {
  publisher: Pick<IndexPublisher, 'identities' | 'athlete' | 'facebookPage'>;
  render?: (contents: React.ReactNode) => React.ReactNode;
}

export default function PublisherCommentModerationPill(props: Props) {
  const { publisher, render: renderFn } = props;
  const currentSuggester = useCurrentUser()?.currentSuggester;
  const { t } = useIntl();

  if (!currentSuggester?.accountConfiguration?.maxAthletes) return null;
  if (!publisher.athlete) return null;

  // Instagram needs to both enable moderation and grant permission
  // Facebook only needs to enable moderation
  const moderationEnabled =
    publisher.identities?.some(
      (i) => i.wantsModeration && i.grantedModerationPermission
    ) || publisher.facebookPage?.wantsModeration;

  if (!moderationEnabled) return null;

  const contents = (
    <Pills.Pill>
      <IconShieldOutline className="mr-0.5 h-2 w-2" />
      <span className="whitespace-nowrap">
        {t('Athlete__WantsCommentModeration')}
      </span>
    </Pills.Pill>
  );

  return renderFn ? <>{renderFn(contents)}</> : contents;
}
